<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      focus: true,
      timeout: null
    };
  },

  methods: {
    ...mapActions("orderScheduler", ["setDescription"]),

    updateDescription(event) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      const description = event.target.value;

      if (description.length > 980) {
        return;
      }

      this.timeout = setTimeout(() => this.setDescription(description), 1000);
    }
  },

  computed: {
    ...mapState("orderScheduler", ["description"])
  }
};
</script>

<template>
  <div class="root">
    <p>Escreva aqui as instruções e cuidados para a sua limpeza.</p>

    <textarea
      placeholder='Por exemplo: "Concentrar a limpeza no banheiro (principalmente no box e mofo das paredes) e cozinha. Utilizar o tempo restante para os quartos e sala." ou "Limpeza dos pisos do escritório e retirada de pó. Por favor, afaste os móveis para limpar embaixo..."'
      name="description"
      ref="description"
      class="description"
      rows="5"
      maxlength="980"
      :class="{'has-error': description.length === 980, 'pulse': focus}"
      :value="description"
      @input="updateDescription"
      @focus="focus = true"
      @blur="focus = false"
    />

    <p class="alert"><b>Importante</b>: o profissional <b>não levará balde, vassoura, rodo, escada ou demais ferramentas ou EPI's</b>. Se esses itens forem necessários, devem estar disponíveis no local da limpeza.</p>
  </div>
</template>

<style scoped>
.root {
  width: 100%;
}

p {
  margin-top: 0;
  font-size: 12px;
  text-align: center;
}
.alert {
  color: #af006b;
}

.description {
  width: calc(100% - 24px - 2px);
  padding: 12px;
  resize: none;
  border: solid 1px #af006b;
  border-radius: 2px;
  height: 120px;
}
.description.pulse {
  box-shadow: 0 0 0 rgba(175, 0, 107, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0.4);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 10px rgba(175, 0, 107, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/AdditionalInformation/Description.vue